import React from 'react';
import { Pencil, Check } from 'lucide-react';
import { useSiteContent } from '@/contexts/SiteContentContext';

/**
 * Floating "Edit Mode" toggle, visible only to admins. When ON, EditableText/EditableButton
 * show edit pencils across the page.
 */
export default function EditModeToggle() {
  const { isAdmin, editMode, setEditMode } = useSiteContent();
  if (!isAdmin) return null;

  return (
    <button
      onClick={() => setEditMode(!editMode)}
      data-testid="edit-mode-toggle"
      className={`fixed bottom-5 left-5 z-[90] flex items-center gap-2 px-4 py-2.5 rounded-full font-bold shadow-xl transition-colors ${
        editMode ? 'bg-[#4D9E7C] text-white' : 'bg-[#1B4B5A] text-white hover:bg-[#143a45]'
      }`}
      title="Toggle inline editing"
    >
      {editMode ? <Check className="w-4 h-4" /> : <Pencil className="w-4 h-4" />}
      {editMode ? 'Editing On' : 'Edit Page'}
    </button>
  );
}
